import { ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { BaseComponent } from '../general/base/base.component';
import { OverlayPanelComponent } from '../overlay-panel/overlay-panel.component';
import { Site24Monitor } from './monitor.definitions';
import { MonitorService } from './monitor.service';
import { takeUntil } from 'rxjs/operators';
import { firstValueFrom, Subject } from 'rxjs';
import { _ } from '~shared/utils';
import { AuthService } from '~app/auth/auth.service';

@Component({
  selector: 'qm-monitors',
  templateUrl: './monitors.component.html',
  styleUrls: ['./monitors.component.scss']
})
export class MonitorsComponent extends BaseComponent implements OnInit, OnDestroy {

  @ViewChild('overlay', { static: true })
  public overlay: OverlayPanelComponent;

  public tenantsMonitors: Site24Monitor;
  /**
   * Subscription manager
   * @type {Subject<any>}
   */
  private readonly ngUnsubscribe: Subject<void> = new Subject();

  constructor(
    private readonly monitorService: MonitorService,
    private readonly changeDetectorRef: ChangeDetectorRef,
    private readonly authService: AuthService) {
    super();
    this.name = 'MonitorsComponent';
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  ngOnInit() {
    const init = () => {
      this.monitorService.monitors$.pipe(takeUntil(this.ngUnsubscribe))
        .subscribe((data) => {
          this.tenantsMonitors = data;
          this.changeDetectorRef.markForCheck();
        });
    };

    firstValueFrom(this.authService.login$).then(() => {
      console.log('Got session, initializing monitors component');
      init();
    });
  }

  /** @returns A link to the monitor-specific status page, if one exists. */
  public site24MonitorLink(monitor: Site24Monitor['monitorList'][0]): string | undefined {
    for (const tag of monitor.tags) {
      if (tag.startsWith('LINK:')) {
        return tag.substr('LINK:'.length);
      }
    }
  }

  /**
   * Found at least three statuses from site24 to show on tooltip..
   * @param status site24 status as number
   */
  public site24StatusAsString(status: number): string {
    switch (status) {
      case 0:
        return _('down');
      case 1:
        return _('up');
      case 2:
        return _('warning');
      default:
        return _('unknown');
    }
  }

  /**
   * mask all statuses to DOWN (false/red) or UP (true/green) in that order.
   */
  public site24MainStatusUp(): boolean {
    if (this.tenantsMonitors?.monitorList.some( item => item.status === 0 || item.status === 2)) {
      return false;
    } else {
      return true;
    }
  }
}
